import { handleActions } from "redux-actions";
import {
  FETCH_HEATMAP_DATA_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  SET_FILTERS_DIRTY,
  SET_LOADING,
  RESET_FILTERS,
  UPDATE_SECONDARY_CATEGORY,
  SET_MEMBERSHIP_LOGIC
} from "./heatmapSaga";

export const initialState = {
  data: [],
  links: [],
  month: {},
  riders: {},
  filters: false,
  isLoading: false,
  secondaryCategories: [],
  selectedSecondaryCategories: [],
  filtersDirty: false,
  membershipLogic: null
};

export default handleActions(
  {
    [FETCH_HEATMAP_DATA_SUCCESS]: (
      state,
      { payload: { data, links, months, riders, filters } }
    ) => ({
      ...state,
      data: data || state.data,
      links: links || state.links,
      month: months || state.month,
      riders: riders || state.riders,
      filters: filters || state.filters
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      secondaryCategories: action.payload.secondary_categories,
      selectedSecondaryCategories: action.payload.secondary_categories
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_LOADING]: (state, { payload }) => ({
      ...state,
      isLoading: payload
    }),
    [RESET_FILTERS]: (state) => ({
      ...state,
      filtersDirty: false,
      selectedSecondaryCategories: state.secondaryCategories
    }),
    [UPDATE_SECONDARY_CATEGORY]: (state, action) => ({
      ...state,
      selectedSecondaryCategories: action.payload,
      filtersDirty: true
    }),
    [SET_MEMBERSHIP_LOGIC]: (state, { payload }) => ({
      ...state,
      membershipLogic: payload
    })
  },

  initialState
);
